export default "__VITE_ASSET__4vQddqOM__"